import { render } from "./Autocomplete.vue?vue&type=template&id=a86972fc&scoped=true"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=a86972fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a86972fc"

export default script